import IconButton from 'components/IconButton';
import { useAtomValue, useSetAtom } from 'jotai';
import callApi from 'lib/callApi';
import { showFailureToast, showSuccessToast } from 'lib/ToastHelper';
import moment from 'moment';
import React, { useState } from 'react';
import { CircleSpinner } from 'react-spinners-kit';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledTooltip,
} from 'reactstrap';

import { selectedWebAppsFilterAtom, waListingDataAtom } from './state';
import WADetailModal from './WADetailModal';
import history from '../../../../../history';
import { getDrillDownUrl, getItemFromLocalStorage } from '../../helper';
import { WAFilter } from '../config';
import { waRefreshAtom } from '../state';

const BASE_URL: string = getItemFromLocalStorage('approle') || '';
const RowActions = ({ rowData }) => {
  const scanInProgress: boolean = ['in_progress'].includes(
    rowData['manual_scan__status'],
  );
  const rowId = rowData['id'];
  let isDeleted = rowData['deleted_webapp__deleted_at'] ? true : false;
  const isActive = rowData['is_active'];
  const isInActive = !isDeleted && !rowData['is_active'] ? true : false;

  let deletedDate = rowData['deleted_webapp__deleted_at'];
  let deletedBy = rowData['deleted_webapp__deleted_by'];

  let deactivatedBy = rowData['deactivated_by'];
  let deactivatedDate = rowData['last_deactivated_at'];

  //   NEW
  const [_manualScanLoadingMap, setManualScanLoadingMap] = useState({});
  const waListingData = useAtomValue(waListingDataAtom);
  const [confirmManualScanLoading, setConfirmManualScanLoading] =
    useState(false);
  const [ManualScanData, setManualScanData] = useState([]);
  const [cancelScanModal, setCancelScanModal] = useState(false);
  const [WASManualScan, setWASManualScan] = useState(false);
  const selectedWebAppsFilter = useAtomValue(selectedWebAppsFilterAtom);
  const [isPerformingAction, setIsPerformingAction] = useState(false);

  const setWARefresh = useSetAtom(waRefreshAtom);

  const [confirmModal, setConfirmModal] = useState(false);
  const [detailModal, setDetailModal] = useState({
    isOpen: false,
    waId: 0,
    scanInProgress: false,
    deactivatedBy: '',
    deletedBy: '',
    deletedDate: '',
    deactivatedDate: '',
    inactive: isInActive,
  });

  const renderDetailModal = () => {
    return (
      <Modal isOpen={detailModal.isOpen} toggle={closeDetailModal} size="lg">
        <ModalHeader toggle={closeDetailModal}>
          <h4>Web App Details</h4>
        </ModalHeader>
        <ModalBody>
          {detailModal.waId > 0 && <WADetailModal id={detailModal.waId} />}
          {selectedWebAppsFilter === WAFilter.DELETED &&
            detailModal.deletedDate && (
              <p>
                <strong>
                  This web app was deleted by{' '}
                  {detailModal.deletedBy?.length
                    ? detailModal.deletedBy
                    : 'SP360'}{' '}
                  at {moment(detailModal.deletedDate).format('lll')}
                </strong>
              </p>
            )}
          {selectedWebAppsFilter === WAFilter.INACTIVE &&
            detailModal.inactive && (
              <p>
                <strong>
                  This web app was deactivated by{' '}
                  {detailModal.deactivatedBy?.length
                    ? `${detailModal.deactivatedBy} at ${moment(
                        detailModal.deactivatedDate,
                      ).format('lll')}`
                    : 'SP360'}{' '}
                </strong>
              </p>
            )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => closeDetailModal()}>
            Cancel
          </Button>
          {(selectedWebAppsFilter === WAFilter.ACTIVE ||
            selectedWebAppsFilter === WAFilter.INACTIVE) && (
            <>
              <span id="confirmDeactivateButton">
                <Button
                  disabled={detailModal.scanInProgress && !detailModal.inactive}
                  color={detailModal.inactive ? 'success' : 'danger'}
                  onClick={() => setConfirmModal(true)}
                >
                  {detailModal.inactive ? 'Reactivate' : 'Deactivate'}
                </Button>
              </span>
              {detailModal.scanInProgress && !detailModal.inactive && (
                <UncontrolledTooltip
                  placement="top"
                  target="confirmDeactivateButton"
                >
                  Deactivation unavailable during ongoing manual scan.
                  <br /> Cancel or wait for completion.
                </UncontrolledTooltip>
              )}
            </>
          )}
        </ModalFooter>
      </Modal>
    );
  };

  const openDetailModal = (
    waId,
    deactivatedBy,
    deactivatedDate,
    deletedBy,
    deletedDate,
    inactive,
    scanInProgress,
  ) => {
    setDetailModal({
      isOpen: true,
      waId: waId,
      deactivatedBy: deactivatedBy,
      deactivatedDate: deactivatedDate,
      deletedBy: deletedBy,
      deletedDate: deletedDate,
      inactive: inactive,
      scanInProgress: scanInProgress,
    });
  };

  const closeDetailModal = () => {
    setDetailModal({ ...detailModal, isOpen: false });
  };

  async function confirmManualScan() {
    setWASManualScan(false);
    // Set loading status for the specific item to true
    setManualScanLoadingMap((prevLoadingMap) => ({
      ...prevLoadingMap,
      [ManualScanData['webapp_id']]: true,
    }));
    setConfirmManualScanLoading(true);
    let url = 'manual_scans/' + ManualScanData['webapp_id'];
    await callApi(url, 'GET', {})
      .then((res) => {
        if (res.status === 200) {
          if (res.data.status === 'failed') {
            showFailureToast(res.data.message);
          } else if (res.data.manual_scan__id) {
            let updatedwaListingData = waListingData.items.find(
              (x) => x.webapp_id === ManualScanData['webapp_id'],
            );
            if (updatedwaListingData) {
              updatedwaListingData['manual_scan__id'] =
                res.data.manual_scan__id;
              updatedwaListingData['manual_scan__status'] = 'in_progress';
              // setReload(Math.random().toString())
              showSuccessToast('Manual Scan launched successfully.');
            }
          }
        } else {
          showFailureToast(`Failed to launch manual scan. ${res.status}`);
        }
      })
      .catch((err) => {
        throw err;
      })
      .finally(() => {
        // Set loading status for the specific item to false
        setManualScanLoadingMap((prevLoadingMap) => ({
          ...prevLoadingMap,
          [ManualScanData['webapp_id']]: false,
        }));
        setConfirmManualScanLoading(false);
      });
  }

  async function cancelWASManualScan() {
    setCancelScanModal(false);
    // Set loading status for the specific item to false
    setManualScanLoadingMap((prevLoadingMap) => ({
      ...prevLoadingMap,
      [ManualScanData['webapp_id']]: true,
    }));
    setConfirmManualScanLoading(true);
    let url = 'manual_scans/cancel/';
    await callApi(url, 'POST', {}, { webapp_id: ManualScanData['webapp_id'] })
      .then((res) => {
        if (res.data.status === 'success') {
          showSuccessToast('Manual Scan cancelled successfully.');
          let updatedwaListingData = waListingData.items.find(
            (x) => x.webapp_id === ManualScanData['webapp_id'],
          );
          if (updatedwaListingData) {
            updatedwaListingData['manual_scan__status'] = 'cancelled';
            // setReload(Math.random().toString())
          }
        } else if (res.data.status === 'failed') {
          showFailureToast(res.data.message);
        } else {
          showFailureToast(`Failed to cancel manual scan. ${res.status}`);
        }
      })
      .catch((err) => {
        throw err;
      })
      .finally(() => {
        // Set loading status for the specific item to false
        setManualScanLoadingMap((prevLoadingMap) => ({
          ...prevLoadingMap,
          [ManualScanData['webapp_id']]: false,
        }));
        setConfirmManualScanLoading(false);
      });
  }

  const handleWAReactivateDeactivate = async (id) => {
    setIsPerformingAction(true);
    await callApi(
      `web_apps/${id}/deactivate/`,
      'PATCH',
      {},
      { deactivate: !isInActive },
    )
      .then((res) => {
        if (res.status === 200) {
          // update the listing data and counts
          //   let updatedwaListingData = waListingData.items.filter(
          //     (x) => x.id !== id
          //   );
          //   waListingData.items = updatedwaListingData;
          //   waListingData.count = updatedwaListingData.length;
          // setReload(Math.random().toString())
          showSuccessToast(
            `Web App ${
              isInActive ? 'reactivated' : 'deactivated'
            } successfully.`,
          );
        } else {
          showFailureToast(
            `Failed to ${
              isInActive ? 'reactivate' : 'deactivate'
            } Web App. Status: ${res.status}`,
          );
        }
      })
      .catch((err) => {
        let res = err.response;
        let error = 'Unknown error occured. Please try again.';
        if (res && res.data) {
          error = res.data.detail;
          showFailureToast(error);
        }
      })
      .finally(() => {
        setIsPerformingAction(false);
        setConfirmModal(false);
        closeDetailModal();
        setWARefresh(Math.random().toString());
      });
  };

  const renderConfirmModal = () => {
    return (
      <Modal isOpen={confirmModal} size="sm">
        <ModalHeader>
          <h4>
            {detailModal.inactive ? 'Reactivate' : 'Deactivate'} Confirmation
          </h4>
        </ModalHeader>
        <ModalBody>
          <p>
            Are you sure you want to{' '}
            {detailModal.inactive ? 'reactivate' : 'deactivate'} this Web App?
          </p>
          <label className="text-warning">
            Note: This request will result in a temporary discrepancy in the
            count shown on the historical trending charts and will be resolved
            with the next synchronization, which is scheduled for every 2 hours.
          </label>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setConfirmModal(false)}>
            Cancel
          </Button>
          {isPerformingAction ? (
            <CircleSpinner size={20} color="#0665a9" loading={true} />
          ) : (
            <Button
              color={detailModal.inactive ? 'success' : 'danger'}
              disabled={isPerformingAction}
              onClick={() => handleWAReactivateDeactivate(detailModal.waId)}
            >
              {detailModal.inactive ? 'Reactivate' : 'Deactivate'}
            </Button>
          )}
        </ModalFooter>
      </Modal>
    );
  };
  const renderConfirmInvokeManualScanModal = () => {
    return (
      <Modal isOpen={WASManualScan} size="sm">
        <ModalHeader>Invoke Manual Scan</ModalHeader>
        <ModalBody>
          <p>Are you sure you want to proceed?</p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setWASManualScan(false)}>
            Cancel
          </Button>
          <Button
            color="primary"
            disabled={confirmManualScanLoading}
            onClick={() => confirmManualScan()}
          >
            Confirm
          </Button>
        </ModalFooter>
      </Modal>
    );
  };

  const renderConfirmCancelManualScanModal = () => {
    return (
      <Modal isOpen={cancelScanModal} size="sm">
        <ModalHeader>Cancel Manual Scan</ModalHeader>
        <ModalBody>
          <p>Are you sure you want to cancel this scan?</p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setCancelScanModal(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={() => cancelWASManualScan()}>
            Confirm
          </Button>
        </ModalFooter>
      </Modal>
    );
  };

  const manualScanSpinner = (
    <CircleSpinner size={20} color="#0665a9" loading={true} />
  );

  const getActiveIconToolTip = () => {
    let tooltip = isActive
      ? 'Deactivate scanning for this web app'
      : 'Activate scanning for this web app';

    if (isInActive) {
      tooltip = 'This web app is inactive.';
    }

    return tooltip;
  };

  return (
    <div className="text-nowrap">
      {!isDeleted && (
        <IconButton
          id={`toggle_${rowId}`}
          iconClass={`fa-solid ${isActive ? 'fa-toggle-on' : 'fa-toggle-off'}`}
          size="sm"
          disabled={isPerformingAction}
          tooltip={getActiveIconToolTip()}
          onClick={() => handleWAReactivateDeactivate(rowData['id'])}
        />
      )}
      {!isDeleted && (
        <>
          {scanInProgress ? (
            <IconButton
              id="manualscanSpinner"
              size="sm"
              tooltip="Cancel Scan in Progress"
              disabled={isInActive || isPerformingAction}
              onClick={() => {
                setCancelScanModal(true);
                setManualScanData(rowData);
              }}
              iconElement={manualScanSpinner}
            />
          ) : (
            <label className="m-auto">
              <IconButton
                id="manualscanLink"
                iconClass="fa fa-search"
                size="sm"
                disabled={isInActive || isPerformingAction}
                tooltip={
                  isInActive
                    ? "This feature isn't available for inactive webapps"
                    : 'Invoke Manual Scan'
                }
                onClick={() => {
                  setWASManualScan(true);
                  setManualScanData(rowData);
                  // setManualScanIndex(index)
                }}
              />
            </label>
          )}
        </>
      )}
      {!isDeleted && (
        <IconButton
          id="vulnLink"
          iconClass="fa-solid fa-bug"
          size="sm"
          tooltip={
            isActive
              ? 'View Vulnerabilities'
              : 'Action disabled for inactive web apps'
          }
          disabled={isInActive || isPerformingAction}
          onClick={() =>
            history.push(
              getDrillDownUrl({
                type: 'open',
                sourceType: 'was_data',
                hosts_in: [rowData.id],
                severity: '',
                issueType: '',
                qid: '',
                severity_in: undefined,
              }),
              // `/${BASE_URL}/qualys/vulnerabilities?source_type=was_data&webapp=${rowData['id']}`,
            )
          }
        />
      )}
      <IconButton
        id="disabledetailsLink"
        iconClass="fa fa-eye"
        size="sm"
        tooltip="View Web App Details"
        onClick={() =>
          openDetailModal(
            rowData['id'],
            deactivatedBy,
            deactivatedDate,
            deletedBy,
            deletedDate,
            isInActive,
            scanInProgress,
          )
        }
      />
      {detailModal.isOpen && renderDetailModal()}
      {confirmModal && renderConfirmModal()}
      {WASManualScan && renderConfirmInvokeManualScanModal()}
      {cancelScanModal && renderConfirmCancelManualScanModal()}
    </div>
  );
};

export default RowActions;
